import { styled, typography } from '@pulse-web-ui/theme';

export const InputContainer = styled.div`
  ${typography.regular14};
  display: flex;
  align-items: center;
  border: 2px dashed ${({ theme }) => theme.colors.neutral[30]};
  border-radius: calc(${({ theme }) => theme.common.radius} * 3);
  padding: 24px;
  margin-bottom: 16px;
`;

export const Label = styled.p`
  ${typography.regular18};
  margin: 0;
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: center;
`;

export const RotatedIcon = styled.span`
  transform: rotate(45deg);
`;

export const ButtonAdd = styled.div`
  display: flex;
  justify-content: center;
  padding: 24px 0;
  background-color: ${({ theme }) => theme.colors.neutral[10]};
  border-radius: calc(${({ theme }) => theme.common.radius} * 3);
  margin-bottom: 12px;
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Messages = styled.div`
  ${typography.regular14};
  line-height: 20px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ErrorText = styled.span`
  color: ${({ theme }) => theme.colors.text.error};
`;
